import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbDataValueRenderer } from "abreact/data/AbDataValueRenderer";
import { AbDataValueUtils } from "abreact/data/AbDataValueUtils";
import * as AbFormHooks from "abreact/form/AbFormHooks";
import * as AbReactResources from "abreact/generated/locale/AbReactResources";
import { FocusUtils } from "abreact/incubator/ui/utils/FocusUtils";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbPasswordInput } from "abreact/input/AbPasswordInput";
import { AbButton, AbButtonType } from "abreact/misc/AbButton";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
import { StringUtils } from "abweb/utils/StringUtils";
import * as React from "react";
export const PASSWORD_INDICATOR = "********";
export function AbPasswordDataValueInput(props) {
  const viewModel = AbFormHooks.useDataValueInputViewModel("ab-password-data-value-input", props);
  const isMounted = React.useRef(false);
  const passwordInputRef = React.useRef(null);
  const [changeClickTracker, setChangeClickTracker] = React.useState(false);

  // if the change button was clicked, automatically focus on the input
  React.useEffect(() => {
    if (isMounted.current) {
      FocusUtils.setFocus(passwordInputRef.current?.inputElement);
    } else {
      isMounted.current = true;
    }
  }, [changeClickTracker]);
  if (!viewModel) {
    return null;
  }
  const {
    inputProps,
    readOnlyProps,
    currentValue
  } = viewModel;
  const {
    tooltip,
    id,
    style,
    className,
    dataTestId,
    ...remainingInputProps
  } = inputProps;
  const savedPassword = props.accessor.getServerValue && props.subject ? props.accessor.getServerValue(props.subject) : undefined;
  const hasClientChange = props.subject ? AbDataValueUtils.canRevertDataValue(props.subject, props.accessor) : false;
  const componentProps = viewModel.isEditing ? ReactUtils.componentProps("ab-password-data-value-input", inputProps) : ReactUtils.componentProps("ab-password-data-value-input", readOnlyProps);
  return /*#__PURE__*/React.createElement(AbWithTooltip, {
    tooltip: tooltip,
    popupProps: {
      className: className
    }
  }, !viewModel.isEditing ? currentValue != null && props.valueRenderer ? /*#__PURE__*/React.createElement("div", _extends({}, componentProps, readOnlyProps), props.valueRenderer(currentValue)) : /*#__PURE__*/React.createElement(AbDataValueRenderer, _extends({}, componentProps, readOnlyProps, {
    subject: props.subject,
    accessor: props.accessor,
    currentValue: currentValue
  })) : !savedPassword || hasClientChange ? /*#__PURE__*/React.createElement("div", _extends({}, componentProps, {
    className: className
  }), /*#__PURE__*/React.createElement(AbPasswordInput, _extends({}, remainingInputProps, {
    abRef: passwordInputRef,
    name: props.name ?? props.accessor.name,
    value: StringUtils.emptyIfNull(currentValue),
    maxLength: props.accessor.constraints?.maxLength,
    onChange: newPassword => {
      viewModel.changeValue(newPassword !== "" ? newPassword : null);
    }
  }))) : /*#__PURE__*/React.createElement("div", _extends({}, componentProps, readOnlyProps, {
    className: ReactUtils.classNamesString([className, "ab-password-change-password-view"])
  }), PASSWORD_INDICATOR, /*#__PURE__*/React.createElement(AbButton, {
    label: AbReactResources.passwordInput_changePasswordLabel(),
    className: "ab-password-data-value-input-change-button",
    type: AbButtonType.LINK,
    onClick: () => {
      setChangeClickTracker(!changeClickTracker);
      viewModel.changeValue(null);
    }
  })));
}
//# sourceMappingURL=AbPasswordDataValueInput.js.map
